import { IconButton, MenuItem } from '@affine/component';
import { CATEGORY_DIVIDER_KEEP_ACTIONS_ACTIVE_ATTR } from '@affine/core/modules/app-sidebar/views';
import { SidebarCreateButton } from '@affine/core/modules/app-sidebar/views/sidebar-create-button';
import { FolderIcon, PageIcon, PlusIcon } from '@blocksuite/icons/rc';
import { useRef } from 'react';

import { StreamLainMenu } from '../../../../../components/dropdown-panel-chrome/radix-menu';
import type { SidebarCreateAction } from '../../../../../modules/app-sidebar/views/area-actions/create-actions';

const KEEP_ACTIONS_ACTIVE_PROPS = {
  [CATEGORY_DIVIDER_KEEP_ACTIONS_ACTIVE_ATTR]: 'true',
} as const;

export function OrganizeCreateMenu({
  actions,
  prominent = false,
  testId = 'navigation-panel-bar-add-organize-button',
  tooltip,
}: {
  actions: readonly SidebarCreateAction[];
  prominent?: boolean;
  testId?: string;
  tooltip: string;
}) {
  const triggerRef = useRef<HTMLButtonElement | null>(null);

  if (actions.length === 0) {
    return null;
  }

  return (
    <StreamLainMenu
      triggerRef={triggerRef}
      contentOptions={{
        align: 'center',
        side: 'right',
      }}
      items={actions.map(action => (
        <MenuItem
          key={action.kind}
          data-testid={`navigation-panel-create-${action.kind}-action`}
          prefixIcon={
            action.kind === 'document' ? <PageIcon /> : <FolderIcon />
          }
          onClick={action.onSelect}
        >
          {action.label}
        </MenuItem>
      ))}
    >
      {prominent ? (
        <SidebarCreateButton
          {...KEEP_ACTIONS_ACTIVE_PROPS}
          ref={triggerRef}
          testId={testId}
          label={tooltip}
        />
      ) : (
        <IconButton
          {...KEEP_ACTIONS_ACTIVE_PROPS}
          ref={triggerRef}
          data-testid={testId}
          size="16"
          tooltip={tooltip}
        >
          <PlusIcon />
        </IconButton>
      )}
    </StreamLainMenu>
  );
}
